package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.manual.enumeration.CustomErrorCodes
import pt.at.oss.kotlin.manual.storage.common.fixedestablishments.FixedEstablishmentsEntry
import pt.lightweightform.kotlin.type.validator.ValidationError

/**
 * Created by Pedro Alfaiate on 15/05/2020.
 */
class FixedEstablishmentsValidator {
    enum class Type { ESTABLISHMENT, CONSIGNMENT }

    val validateFixedEstablishmentsSequencial = fun(fixedEstablishments: List<FixedEstablishmentsEntry>, allowedTypes: List<Type>): List<ValidationError> {
        val errors = mutableListOf<ValidationError>()
        val forceEstablished = !allowedTypes.contains(Type.CONSIGNMENT)
        val forceConsignment = !allowedTypes.contains(Type.ESTABLISHMENT)

        fixedEstablishments.forEach { fixedEstab ->
            if (forceEstablished && !fixedEstab.hasRealEstablishment) {
                errors.add(ValidationError(CustomErrorCodes.FIXED_ESTABLISHMENT_NOT_REAL.code))
            }
            if (forceConsignment && fixedEstab.hasRealEstablishment) {
                errors.add(ValidationError(CustomErrorCodes.FIXED_ESTABLISHMENT_NOT_STOCK.code))
            }

            // taxIdentif__isoA2+vat+tax__
            errors.addAll(FIXED_ESTAB_VAT_ID_VALIDATOR.validateVatIdSequencial(fixedEstab.taxIdentif))

            // tradingName
            // ->required and maxLength
            FreeTextValidator.validateFreeText(fixedEstab.tradingName)?.also { errors.add(it) }

            // address
            errors.addAll(AddressValidator().validateAddressSequencial(fixedEstab.address))
        }

        validateDuplicateFixedEstablishments(fixedEstablishments.map { it.taxIdentif.issuingCountry }.toTypedArray())
            ?.also { errors.add(it) }

        return errors
    }

    val validateDuplicateFixedEstablishments = fun(fixedEstablishments: Array<String?>): ValidationError? {

        val auxFixedEstablishmentsList = fixedEstablishments.distinct()

        return if (auxFixedEstablishmentsList.size != fixedEstablishments.size) {
            ValidationError(CustomErrorCodes.FIXED_ESTABLISHMENT_DUPLICATED.code)
        } else {
            null
        }
    }
}
